import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showCategory?: boolean;
}

export default function ComicCard({ comic, showCategory = true }: ComicCardProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000000) return `${(views / 10000000).toFixed(1)}千万`;
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画大全免费在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${
            comic.status === '连载'
              ? 'bg-accent-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-950/50 backdrop-blur-sm">
            <span className="text-xs font-bold text-amber-400">{comic.rating}</span>
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <span className="text-xs text-white font-medium whitespace-nowrap">立即阅读 →</span>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>

      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{comic.author}</span>
        <span className="text-foreground-300">·</span>
        <span>{formatViews(comic.views)}</span>
      </div>

      {showCategory && (
        <Link
          to={`/category/${comic.categorySlug}`}
          className="inline-block mt-2 px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-900 hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
        >
          {comic.category}
        </Link>
      )}
    </Link>
  );
}